import { useDebounce } from './use-debounce';

const errorMessageDelay = 400;

// Shorter delay to clear the error (otherwise the error appears to hang around after it has been resolved).
const errorMessageDelayToUndefined = 100;

export const useDebounceErrorMessage = <TValue>(value: TValue): TValue =>
    useDebounce(value, errorMessageDelay, errorMessageDelayToUndefined);
